import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  search_job_action,
  user_meta_data_action,
  get_all_skills_action,
} from "../../../redux/_actions";

function useJobListing(props) {
  const [loading, setLoading] = useState(false);
  const [allJobs, setAllJobs] = useState([]);

  //PAGINATION
  const [lastElement, setLastElement] = useState(null);
  const [skillsListLoading, setSkillsListLoading] = useState(false);
  const [skillsTagsAdded, setSkillsTagsAdded] = useState([]);
  const [showSearch, setShowSearch] = useState(false);
  const [candidateSelectedSkill, setCandidateSelectedSkill] = useState([]);
  const [candidateSelectedEmployment, setCandidateSelectedEmployment] =
    useState([]);
  const [candidateSelectedExperience, setCandidateSelectedExperience] =
    useState([]);
  const [candidateSelectedCountry, setCandidateSelectedCountry] = useState([]);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [showSkillSearch, setShowSkillSearch] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchInputRef = useRef();
  const searchSkillInputRef = useRef();

  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);

  const { jobSearchDataList } = useSelector(
    (state) => state.search_job_reducer
  );

  const { allSkillsData } = useSelector(
    (state) => state.get_all_skills_reducer
  );

  useEffect(() => {
    getUserMeta();
  }, []);

  useEffect(() => {
    setLoading(true);
  }, [userMetaData]);

  useEffect(() => {
    if (jobSearchDataList?.data) {
      setAllJobs(jobSearchDataList?.data);
    }
  }, [jobSearchDataList]);

  useEffect(() => {
    if (allSkillsData?.data) {
      setSkillsTagsAdded(allSkillsData?.data);
    }
  }, [allSkillsData]);

  useEffect(() => {
    getAllJobs();
  }, [
    candidateSelectedSkill,
    candidateSelectedEmployment,
    candidateSelectedExperience,
    candidateSelectedCountry,
    searchInputValue,
  ]);

  const getUserMeta = async () => {
    await dispatch(user_meta_data_action());
  };

  const onJobApplyClick = (id, index) => {
    navigate(`/job-board-expanded/`, {
      state: {
        job_id: id,
        index: index,
      },
    });
  };
  const callSkillsApi = async (value) => {
    setSkillsListLoading(true);
    const data = { index: "skill", search_key: "", search: value ? value : "" };
    await dispatch(get_all_skills_action(data));
    setSkillsListLoading(false);
  };

  const onLoginClick = () => {
    navigate("/sign-in", {
      state: { navigateRoute: `/job-board/` },
    });
  };

  const onSearch = () => {
    if (showSearch) {
      searchInputRef.current.value = "";
    }
    setShowSearch((showSearch) => !showSearch);
    setSearchInputValue("");
    getAllJobs();
  };

  const getAllJobs = async () => {
    const data = {
      index: "job_posting",
      search_key: "",
      search: searchInputValue ? searchInputValue : "",
      employment_type:
        Array.isArray(candidateSelectedEmployment) &&
        candidateSelectedEmployment.length
          ? candidateSelectedEmployment
          : [],
      experience:
        Array.isArray(candidateSelectedExperience) &&
        candidateSelectedExperience.length
          ? candidateSelectedExperience
          : [],
      country:
        Array.isArray(candidateSelectedCountry) &&
        candidateSelectedCountry.length
          ? candidateSelectedCountry
          : [],
      skill_names:
        Array.isArray(candidateSelectedSkill) && candidateSelectedSkill?.length
          ? candidateSelectedSkill
          : [],
    };
    setLoading(true);
    await dispatch(search_job_action(data));
    setLoading(false);
  };

  const onSearchInputChange = async (e) => {
    let value = e.target.value;
    if (value.length > 2) {
      setShowSearch(true);
      setSearchInputValue(value);
      onHandleSkillsReset();
      onHandleClearAllFilter();
    } else if (!value.length) {
      onSearch();
    }
  };

  const onCandidateJobsFilterChange = (item, type) => {
    const itemToAdd = item.toLowerCase();
    if (type === "skill") {
      if (!candidateSelectedSkill.includes(itemToAdd)) {
        setCandidateSelectedSkill([...candidateSelectedSkill, itemToAdd]);
        setShowSkillSearch(false);
        searchSkillInputRef.current.value = "";
      }
    }
    if (type === "employment") {
      if (!candidateSelectedEmployment.includes(itemToAdd)) {
        setCandidateSelectedEmployment([
          ...candidateSelectedEmployment,
          itemToAdd,
        ]);
      }
    }
    if (type === "experience") {
      if (!candidateSelectedExperience.includes(itemToAdd)) {
        setCandidateSelectedExperience([
          ...candidateSelectedExperience,
          itemToAdd,
        ]);
      }
    }
    if (type === "country") {
      if (!candidateSelectedCountry.includes(itemToAdd)) {
        setCandidateSelectedCountry([...candidateSelectedCountry, itemToAdd]);
      }
    }
  };

  const onCandidateFilterUnselectClick = (item, type) => {
    const itemToRemove = item.toLowerCase();

    if (type === "skill") {
      if (candidateSelectedSkill.includes(itemToRemove)) {
        const filteredSkills = candidateSelectedSkill.filter(
          (item) => item !== itemToRemove
        );
        setCandidateSelectedSkill(filteredSkills);
      }
    }
    if (type === "employment") {
      if (candidateSelectedEmployment.includes(itemToRemove)) {
        const filteredSkills = candidateSelectedEmployment.filter(
          (item) => item !== itemToRemove
        );
        setCandidateSelectedEmployment(filteredSkills);
      }
    }
    if (type === "experience") {
      if (candidateSelectedExperience.includes(itemToRemove)) {
        const filteredSkills = candidateSelectedExperience.filter(
          (item) => item !== itemToRemove
        );
        setCandidateSelectedExperience(filteredSkills);
      }
    }
    if (type === "country") {
      if (candidateSelectedCountry.includes(itemToRemove)) {
        const filteredSkills = candidateSelectedCountry.filter(
          (item) => item !== itemToRemove
        );
        setCandidateSelectedCountry(filteredSkills);
      }
    }
  };
  const checkSelectedTag = (tag, type) => {
    const tagToCheck = tag.toLowerCase();
    if (type === "skill") {
      return (
        candidateSelectedSkill && candidateSelectedSkill.includes(tagToCheck)
      );
    }
    if (type === "employment") {
      return (
        candidateSelectedEmployment &&
        candidateSelectedEmployment.includes(tagToCheck)
      );
    }
    if (type === "experience") {
      return (
        candidateSelectedExperience &&
        candidateSelectedExperience.includes(tagToCheck)
      );
    }
    if (type === "country") {
      return (
        candidateSelectedCountry &&
        candidateSelectedCountry.includes(tagToCheck)
      );
    }
  };

  const onHandleSkillsReset = () => {
    setCandidateSelectedSkill([]);
  };
  const resetEmployment = () => {
    setCandidateSelectedEmployment([]);
  };
  const resetExperience = () => {
    setCandidateSelectedExperience([]);
  };
  const resetCountryFilter = (e, country) => {
    setCandidateSelectedCountry([]);
  };

  const onHandleClearAllFilter = () => {
    onHandleSkillsReset();
    resetCountryFilter();
    resetExperience();
    resetEmployment();
  };

  const onSkillSearch = () => {
    if (showSkillSearch) {
      if (searchSkillInputRef.current) {
        searchSkillInputRef.current.value = "";
      }
    }
    setShowSkillSearch((showSkillSearch) => !showSkillSearch);
    callSkillsApi();
  };

  const onSearchSkillChange = (e) => {
    let value = e.target.value;
    if (value.length > 2) {
      setShowSkillSearch(true);
      callSkillsApi(value);
    } else if (!value.length) {
      onSkillSearch();
    }
  };

  return {
    userMetaData,
    loading,
    allJobs,
    showSkillSearch,
    skillsTagsAdded,
    showSearch,
    searchInputRef,
    candidateSelectedEmployment,
    candidateSelectedSkill,
    searchSkillInputRef,
    candidateSelectedExperience,
    candidateSelectedCountry,
    onSearch,
    onSearchInputChange,
    setLastElement,
    onJobApplyClick,
    onLoginClick,
    onCandidateJobsFilterChange,
    checkSelectedTag,
    onCandidateFilterUnselectClick,
    onHandleSkillsReset,
    resetEmployment,
    resetExperience,
    resetCountryFilter,
    onHandleClearAllFilter,
    onSearchSkillChange,
    onSkillSearch,
  };
}
export default useJobListing;
